import { api } from 'data/api/api'

import { EducationType } from '../constants/education'

export const markEducationAsRead = (type: EducationType) => api.post('/user/education', { type })
